export const meta = {
    keyExpr: 'id',
    columns: [
        {
            name: 'id',
            caption: 'ID',
            dataField: 'id',
            index: 0,
            visible: false,
        },
        {
            name: 'rownumber',
            caption: '№ п/п',
            dataField: 'rownumber',
            allowEditing: true,
            width: 200,
            visible: true,
        },
        {
            name: 'name',
            caption: 'Наименование показателей',
            dataField: 'name',
            allowEditing: true,
            width: 250,
            visible: true,
        },
        {
            name: 'unit',
            caption: 'Ед.изм.',
            dataField: 'unit',
            allowEditing: true,
            width: 100,
            visible: true,
        },
        {
            name: 'tech_water',
            caption: '160 Тех.вода',
            dataField: 'tech_water',
            allowEditing: false,
            width: 150,
            visible: true,
        },
        {
            name: 'potable_water',
            caption: '170 Пит.вода',
            dataField: 'potable_water',
            allowEditing: false,
            width: 150,
            visible: true,
        },
        {
            name: 'water_disposal',
            caption: '260 Водоотв.',
            dataField: 'water_disposal',
            allowEditing: false,
            width: 150,
            visible: true,
        },
        {
            name: 'total',
            caption: 'Итого',
            dataField: 'total',
            width: 150,
            visible: true,
            allowEditing: false,
        },
        {
            name: 'included_parent',
            caption: 'Статья включена в родительскую',
            dataField: 'included_parent',
            width: 200,
            visible: true,
            dataType: 'boolean',
        },
        {
            name: 'kod_parent',
            caption: 'kod_parent',
            dataField: 'kod_parent',
            allowEditing: true,
            index: 10,
            visible: false,
        },
        {
            name: 'final_value',
            caption: 'Итоговое значение',
            dataField: 'final_value',
            width: 150,
            visible: true,
            dataType: 'boolean',
        }
    ]
};

const columnTitles = {
    tech_water: 'Алгоритм (Тех. вода)',
    potable_water: 'Алгоритм (Питьевая вода)',
    water_disposal: 'Алгоритм (Водоотведение)',
    total: 'Итого',
};

export const getGridMeta = (type) => {
    const caption = columnTitles[type];
    return {
        columns: [
            {
                name: type,
                caption,
                dataField: type,
                keyExpr: type,
                allowEditing: true,
                index: 1,
                visible: true,
                fixed: true,
            },
        ],
    };
};

